import { Type } from '@sinclair/typebox';
import * as Yup from 'yup';

const FIRST_NAME_REGEX = /^[\p{L} ,.'-]{3,40}$/u;
const LAST_NAME_REGEX = /^[\p{L} ,.'-]{2,40}$/u;
const FIRST_NAME_ERROR_COPY =
  "Gunakan huruf, spasi, dan hanya simbol berikut: (') (,) (.) (-)";
const LAST_NAME_ERROR_COPY =
  "Gunakan huruf, spasi, dan hanya simbol berikut: (') (,) (.) (-)";

export const InviteUserSchema = Yup.object().shape({
  email: Yup.string()
    .email('Email harus email yang valid')
    .required('Email harus di isi')
    .label('Email'),
  first_name: Yup.string()
    .transform((v) => (typeof v === 'string' ? v.trim() : v))
    .required('Nama depan harus di isi')
    .test('valid-first-name', FIRST_NAME_ERROR_COPY, (value) =>
      value ? FIRST_NAME_REGEX.test(value) : false
    ),
  last_name: Yup.string()
    .transform((v) => (typeof v === 'string' ? v.trim() : v))
    .required('Nama belakang harus di isi')
    .test('valid-last-name', LAST_NAME_ERROR_COPY, (value) =>
      value ? LAST_NAME_REGEX.test(value) : false
    ),
  shiptos: Yup.array()
    .min(1, 'Pilih salah satu ship to')
    .required('Pilih salah satu ship to')
    .nullable(),
});

export const HumanFirstNameSchema = Type.String({
  minLength: 3,
  maxLength: 40,
  pattern: "^[A-Za-z\\u00C0-\\u02AF\\u1E00-\\u1EFF ,.'-]{3,40}$",
});

export const HumanLastNameSchema = Type.String({
  minLength: 2,
  maxLength: 40,
  pattern: "^[A-Za-z\\u00C0-\\u02AF\\u1E00-\\u1EFF ,.'-]{2,40}$",
});

export const CompanyNameSchema = Type.String({
  minLength: 3,
  pattern: '^[-A-Za-z0-9\\u00C0-\\u02AF\\u1E00-\\u1EFF ,.\'()]+$',
});
